import { useShallow } from 'zustand/react/shallow'
import Message from '#app/features/chat/components/message.tsx'
import { useGlobalChatStore } from '#app/routes/chat+/index.tsx'

export const MessageList = () => {
	const messages = useGlobalChatStore(useShallow(state => state.messages))

	return (
		<div className="mt-10 flex h-full flex-1 flex-col items-center overflow-hidden text-sm">
			{messages.map((message, index) => {
				return (
					<Message
						key={index}
						message={message}
						isLastMessage={
							index === messages.length - 1 && message.role === 'assistant'
						}
					/>
				)
			})}
		</div>
	)
}
